import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const QA = [
  {
    q: "Is my PSN account safe? Will I get banned?",
    a: "The unlock is performed on a PS4 Testkit, not on public servers. This is the safest known route for BO2 account services. Biipod has run hundreds of orders without a single ban.",
  },
  {
    q: "How does the PS4 Testkit method work?",
    a: "Your PSN account is temporarily signed into a dev PS4 Testkit. The Testkit writes prestige, level, unlocks and cosmetic data directly into the BO2 save. It’s injected server-side, then your account is signed off.",
  },
  {
    q: "How long until I see the unlocks?",
    a: "The Testkit process itself takes about 5 minutes. That timer starts when Biipod picks up your order — during busy hours there can be a short queue before that. You'll get a Discord DM the moment your order is picked up and again when delivery is complete.",
  },
  {
    q: "Do you need my PSN password?",
    a: "Yes — Biipod will DM you a secure request for temporary sign-in credentials after payment is confirmed. Change your password before and after if you prefer maximum security.",
  },
  {
    q: "Do you cover PS4 and PS5?",
    a: "The service covers Black Ops 2 on both PS4 and PS5. Just note which platform in the order notes if it matters to you.",
  },
  {
    q: "Refunds?",
    a: "Because this is a digital service delivered in minutes, all sales are final once the Testkit process begins. If delivery fails on our end, you’ll get a full refund via CashApp.",
  },
];

export default function FAQ() {
  return (
    <div className="mx-auto max-w-4xl">
      <div className="mb-10 text-center">
        <div className="font-mono-hud text-xs uppercase tracking-[0.4em] text-[#ff6b00]">
          // Intel Debrief
        </div>
        <h2 className="mt-3 font-display text-5xl uppercase tracking-tight text-zinc-100 sm:text-6xl">
          Frequently Asked
        </h2>
      </div>

      <Accordion type="single" collapsible className="border border-zinc-800 bg-[#0a0a0a]" data-testid="faq">
        {QA.map((item, i) => (
          <AccordionItem
            key={i}
            value={`i-${i}`}
            className="border-b border-zinc-900 last:border-b-0"
            data-testid={`faq-item-${i}`}
          >
            <AccordionTrigger className="px-6 py-5 text-left font-hud text-lg uppercase tracking-wide text-zinc-100 hover:text-[#ff6b00] hover:no-underline data-[state=open]:text-[#ff6b00]">
              <span className="mr-3 font-mono-hud text-xs text-[#ff6b00]">
                {String(i + 1).padStart(2, "0")}
              </span>
              {item.q}
            </AccordionTrigger>
            <AccordionContent className="px-6 pb-6 pt-0 font-hud text-base leading-relaxed text-zinc-400">
              {item.a}
            </AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </div>
  );
}
